/**
 * A campaign-level problem the API recorded, shown on the campaign page until it clears: why task
 * steps couldn't create JobTetris tasks (JT1-1854), or why texts are waiting (JT1-1858).
 */
export function CampaignNoticeBanner({ title, message, at }: { title: string; message?: string | null; at?: string | null }) {
  if (!message) return null;

  const when = at ? new Date(at).toLocaleString() : null;

  return (
    <div
      role="alert"
      style={{
        padding: 'var(--space-3) var(--space-4)',
        borderRadius: 'var(--radius-input)',
        border: '1px solid var(--color-warning)',
        color: 'var(--color-warning)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-sm)',
      }}
    >
      <strong>{title}</strong> {message}
      {when && <span style={{ color: 'var(--color-text-muted)' }}> Last checked {when}.</span>}
    </div>
  );
}

/** Why the campaign's task steps couldn't create JobTetris tasks (JT1-1854). */
export function TaskErrorBanner({ taskError, taskErrorAt }: { taskError?: string | null; taskErrorAt?: string | null }) {
  return <CampaignNoticeBanner title="Follow-up tasks aren't being created in JobTetris." message={taskError} at={taskErrorAt} />;
}
